var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebinarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08702 10.2751H9.81337V9.81202C9.81337 9.20056 9.51289 8.716 8.91193 8.35835C8.31097 8.00068 7.49039 7.82185 6.4502 7.82185C5.41 7.82185 4.58942 8.00068 3.98846 8.35835C3.3875 8.716 3.08702 9.20056 3.08702 9.81202V10.2751ZM6.44884 6.75281C6.92201 6.75281 7.30883 6.60199 7.60931 6.30035C7.90977 5.99872 8.06001 5.6097 8.06001 5.1333C8.06001 4.65688 7.91022 4.26924 7.61066 3.97036C7.31108 3.67147 6.92471 3.52203 6.45155 3.52203C5.97838 3.52203 5.59156 3.67101 5.29108 3.96898C4.99062 4.26696 4.84038 4.65416 4.84038 5.13058C4.84038 5.60698 4.99017 5.99645 5.28973 6.29899C5.58931 6.60154 5.97568 6.75281 6.44884 6.75281ZM1.52926 13.5C1.1109 13.5 0.751443 13.3487 0.450873 13.046C0.150291 12.7434 0 12.3815 0 11.9602V2.05074C0 1.6265 0.150291 1.26198 0.450873 0.957178C0.751443 0.652393 1.1109 0.5 1.52926 0.5H11.3711C11.7925 0.5 12.1545 0.652393 12.4572 0.957178C12.7599 1.26198 12.9113 1.6265 12.9113 2.05074V6.13083L16 3.0209V10.9901L12.9113 7.88016V11.9602C12.9113 12.3815 12.7599 12.7434 12.4572 13.046C12.1545 13.3487 11.7925 13.5 11.3711 13.5H1.52926ZM1.52926 11.9602H11.3711V2.05074H1.52926V11.9602Z",
    fill: "#A5A4BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebinarIcon);
export default __webpack_public_path__ + "static/media/webinar_icon.5fab3682aeb50d6d06d23f4e9ca438a7.svg";
export { ForwardRef as ReactComponent };